export default __webpack_public_path__ + "static/media/edit.175be4e1.svg";